import React, { Component } from "react";

export default class BrandFrontend extends Component {
  render() {
    return (
      <section className="brand">
        <div className="container">
          <div className="row brand-icon">
            <div className="col-md-3 col-6 text-center my-md-auto">
              <img
                src="https://api.elements.buildwithangga.com/storage/files/2/assets/Content/Content10/dark/Slack-Logo.png"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="col-md-3 col-6 text-center my-md-auto">
              <img
                src="https://api.elements.buildwithangga.com/storage/files/2/assets/Content/Content10/dark/Microsoft-Logo.png"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="col-md-3 col-6 text-center my-md-auto mt-5 mt-md-0">
              <img
                src="https://api.elements.buildwithangga.com/storage/files/2/assets/Content/Content10/dark/Google-Logo.png"
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="col-md-3 col-6 text-center my-md-auto mt-5 mt-md-0">
              <img
                src="https://api.elements.buildwithangga.com/storage/files/2/assets/Content/Content10/dark/Airbnb-Logo.png"
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
